export const getExtInfo = (extInfo?: string) => {
    if (!extInfo) {
        return '';
    }

    try {
        return decodeURIComponent(extInfo).trim();
    } catch {
        return extInfo.trim();
    }
};